import SocialMediaIcon from "../SocialMediaIcon/index.jsx";
import {ShareSocialMediaLinksWrapper} from "./styles.js";

import {useTheme} from "@emotion/react";
import facebook from "../../assets/icons/socialNetworks/facebook.svg";
import linkedin from "../../assets/icons/socialNetworks/linkedin.svg";
import mail from "../../assets/icons/socialNetworks/mail.svg";
import twitterX from "../../assets/icons/socialNetworks/twitterX.svg";
import {
  initialFontSize,
  maxStep,
  stepSize,
  useFontSize,
} from "../../context/fontSizeChange.jsx";
import IncreaseFontSize from "../../elements/svgicon/IncreaseFontSize.jsx";
import ReduceFontSize from "../../elements/svgicon/ReduceFontSize.jsx";
import {IconWrapper} from "../StickyBar/styles.js";

function ShareSocialMediaLinks({align = "row", styles = {}}) {
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  const {reduceFontSize, increaseFontSize, fontSize} = useFontSize();
  return (
    <ShareSocialMediaLinksWrapper styles={styles} align={align}>
      <SocialMediaIcon
        to={`https://www.facebook.com/sharer.php?u=${encodeURI(window.location)}`}
        src={facebook}
        target="_blank"
        alt="facebook"
      />
      <SocialMediaIcon
        to={`https://www.linkedin.com/shareArticle?url=${encodeURI(window.location)}`}
        src={linkedin}
        target="_blank"
        alt="linkedin"
      />
      <SocialMediaIcon
        to={`mailto:?subject=${window.location}body=Check out this site "${window.location}"`}
        src={mail}
        target="_blank"
        alt="mail"
      />
      <SocialMediaIcon
        to={`https://twitter.com/share?url=${encodeURI(window.location)}`}
        src={twitterX}
        target="_blank"
        alt="twitterX"
      />
      {isMobile && (
        <>
          <IconWrapper onClick={reduceFontSize}>
            <ReduceFontSize
              width={20}
              height={20}
              color={fontSize === initialFontSize ? "#737373" : "#27509B"}
            />
          </IconWrapper>
          <IconWrapper onClick={increaseFontSize}>
            <IncreaseFontSize
              color={
                fontSize === initialFontSize + stepSize * maxStep ? "#737373" : "#27509B"
              }
              width={20}
              height={20}
            />
          </IconWrapper>
        </>
      )}
    </ShareSocialMediaLinksWrapper>
  );
}

export default ShareSocialMediaLinks;
